// EWM-1009: the dark-theme arc used to be `dark:border-l-dark` (#3b3f5c) on a `dark:bg-c0`
// (#0E0D11) page - 1.89:1, well under the 3:1 WCAG 1.4.11 floor for a non-text graphic, so a
// load read as a frozen screen. The accent gives 9.12:1 on c0 and 7.69:1 on c16, the other dark
// surface. Light theme is deliberately untouched (option (b) on the ticket): black on white is
// already 17.96:1.
//
// Matches the EWM-986 conversion overlay, which fixed this one flow with the same `border-l-c1`
// accent. The overlay also paints a track ring; this component has never had one in either theme,
// and adding it only under `dark:` would make the spinner a different shape per theme, so the
// geometry is left alone and only the colour changes.
//
// ponytail: c1 is `var(--primary)`, which tenants set per-tenant as `highlightColor` with no
// contrast validation anywhere in the write path, so a tenant that picks a near-black accent
// re-creates this defect for itself. Same exposure the EWM-986 overlay already carries. The fix
// is a contrast check on the highlight-colour picker, not more classes here - separate ticket.
export interface LoaderProps {
  size?: 's' | 'm';
  noMargin?: boolean;
}

export const Loader: FC<LoaderProps> = ({ size = 'm', noMargin: noMarging }) => (
  <div className='flex h-full items-center justify-center'>
    <div className='flex items-center'>
      <span
        className={`animate-spin rounded-full border-4 border-transparent border-l-black ${size === 's' ? 'h-7 w-7' : 'h-10 w-10'} m-auto inline-block align-middle ${noMarging ? '' : 'm-5'} dark:border-l-c1`}
      />
    </div>
  </div>
);
